import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = new Map();

export const AuthImage = ({ imageId, alt, className, testid, onFail }) => {
  const [src, setSrc] = useState(() => cache.get(imageId) || null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!imageId || cache.has(imageId)) {
      setSrc(cache.get(imageId) || null);
      return;
    }
    let active = true;
    api
      .get(`/images/${imageId}`, { responseType: "blob" })
      .then((res) => {
        const url = URL.createObjectURL(res.data);
        cache.set(imageId, url);
        if (active) setSrc(url);
      })
      .catch(() => {
        if (!active) return;
        setFailed(true);
        onFail?.();
      });
    return () => {
      active = false;
    };
  }, [imageId, onFail]);

  if (!imageId || failed) return null;
  if (!src)
    return <div className={`animate-pulse bg-slate-200 ${className}`} data-testid={`${testid}-loading`} />;
  return <img src={src} alt={alt || ""} className={className} data-testid={testid} loading="lazy" />;
};

export const CaptionedImage = ({ imageId, caption, className, testid }) => {
  if (!imageId) return null;
  return (
    <figure className="mt-3" data-testid={`${testid}-figure`}>
      <AuthImage imageId={imageId} alt={caption} className={className} testid={testid} />
      {caption && (
        <figcaption
          data-testid={`${testid}-caption`}
          className="mt-1.5 text-xs italic leading-snug text-slate-500"
        >
          {caption}
        </figcaption>
      )}
    </figure>
  );
};
